var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f603090ca3e1428319069ec72414bd09d957375e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["linktracker@z5-internet-ltd"]={id:"f603090ca3e1428319069ec72414bd09d957375e"};
      